import { useRef, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { formatNewLine } from '@/components/common/Intl';
import LazyImg from '@/components/common/LazyImg';
import styles from './New.module.scss';

interface NewProps {
  imgSrc: string;
  time: string;
  label: string;
  title: string;
}
const New: React.FC<NewProps> = ({ imgSrc, label, title, time }) => {
  const labelHtml = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const labelText = labelHtml.current.children[0];
    if (
      labelText.innerHTML === '最新资讯' ||
      labelText.innerHTML === 'Information'
    ) {
      labelHtml.current.style.backgroundColor = 'rgba(255, 184, 0, 0.22)';
      labelHtml.current.style.color = '#EC7100';
    } else if (
      labelText.innerHTML === '市场活动' ||
      labelText.innerHTML === 'Marketing'
    ) {
      labelHtml.current.style.backgroundColor = 'rgba(255, 78, 51, 0.1)';
      labelHtml.current.style.color = '#FB2403';
    } else {
      labelHtml.current.style.backgroundColor = 'rgba(205, 166, 255, 0.22)';
      labelHtml.current.style.color = '#9236ED';
    }
  });
  return (
    <div className={styles.new__container}>
      <div className={styles.image}>
        <LazyImg src={imgSrc} width="378" height="212" alt="" />
      </div>
      <div className={styles.new__content}>
        <div className={styles.label} ref={labelHtml}>
          <FormattedMessage id={label} defaultMessage="" />
        </div>
        <div className={styles.title}>
          <FormattedMessage
            id={title}
            defaultMessage=""
            values={{
              n: formatNewLine,
            }}
          />
        </div>
        <div className={styles.time}>
          <span className={styles.time__svg}>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="7" cy="7" r="6.5" stroke="#9C9EA6" />
              <rect
                x="6.5"
                y="2.5"
                width="1"
                height="5"
                rx="0.5"
                fill="#9C9EA6"
              />
              <rect
                width="1"
                height="5"
                rx="0.5"
                transform="matrix(4.37114e-08 1 1 -4.37114e-08 6.5 6.5)"
                fill="#9C9EA6"
              />
            </svg>
          </span>
          <FormattedMessage id={time} defaultMessage="" />
        </div>
      </div>
    </div>
  );
};

export default New;
